import {
  SearchBar,
  Pagination as DynamicPagination,
  DateRangePicker,
  Icon,
  Dropdown,
  Modal,
} from "@components/index";
import ClaimListRender from "./components/ClaimListRender";
import ClaimDetailsModal from "./components/ClaimDetailsModal";
import ClaimAction from "./components/ClaimAction";
import { useClaimsData, searchOptions, CLAIM_STATUS } from "./claimsData";
import "./index.scss";

const Claims = () => {
  // Use the custom hook for all claims logic
  const {
    claims: paginatedClaims,
    allClaims: filteredClaims,
    loading,
    error,
    searchValue,
    handleSearch,
    fromDate,
    toDate,
    handleDateChange,
    currentPage,
    handlePageChange,
    selectedStatusFilter,
    handleStatusFilterChange,
    handleClearFilters,
    selectedClaim,
    isModalOpen,
    handleViewClaim,
    handleCloseModal,
    modalConfig, // modal config for approve/reject claim
    handleActionClick, // button action for approve/reject claim
    handleCancelAction, // button action for cancel approve/reject claim
    loadClaimsData,
    handleDownloadMISClaims, // download claims mis data
  } = useClaimsData();

  const handleSearchChange = (_, searchValue) => {
    handleSearch(searchValue);
  };

  return (
    <div className="claims-page">
      <div
        className="claims-page__header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h1 className="claims-page__title">Claims Management</h1>
          <p className="claims-page__subtitle">
            Manage ATP claims and approvals
          </p>
        </div>
        <button
          className="claims-page__download-btn"
          onClick={handleDownloadMISClaims}
        >
          <Icon
            iconName="downlaodIcon"
            height={16}
            width={16}
            className="download-icon"
          />
          Download MIS Data
        </button>
      </div>

      <div className="claims-page_filters">
        <div className="claims-page_filters-section">
          <SearchBar
            searchOptions={searchOptions}
            onSearch={handleSearchChange}
            showSearchButton={false}
            initialValue={searchValue}
          />

          <Dropdown
            label="Claim Status"
            value={selectedStatusFilter}
            onChange={handleStatusFilterChange}
            options={CLAIM_STATUS}
            className="claims-page_status-dropdown"
          />

          <DateRangePicker
            fromDate={fromDate}
            toDate={toDate}
            onChange={handleDateChange}
            className="claim_date-range-picker"
          />
        </div>

        <button className="claims-page_clear-btn" onClick={handleClearFilters}>
          Reset Filters
        </button>
      </div>

      {/* Claims List */}
      <ClaimListRender
        claims={paginatedClaims}
        loading={loading}
        error={error}
        onViewClaim={handleViewClaim}
        onActionClick={handleActionClick}
        onClearFilters={handleClearFilters}
      />

      {/* Pagination */}
      <DynamicPagination
        data={filteredClaims}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        itemsPerPage={10}
        showInfo={true}
        showFirstButton={true}
        showLastButton={true}
      />

      {/* Claim Details Modal */}
      <ClaimDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        claim={selectedClaim}
        onActionClick={(claim, action) => handleActionClick(claim, action)}
      />

      {modalConfig && modalConfig.action && (
        <Modal isOpen={modalConfig.action} onClose={handleCancelAction}>
          <ClaimAction
            claimData={modalConfig.claimData}
            claimAction={modalConfig.action}
            handleCancelAction={handleCancelAction}
            loadClaimsData={loadClaimsData}
          />
        </Modal>
      )}
    </div>
  );
};

export default Claims;
